<template>
  <el-breadcrumb class="app-breadcrumb" separator="/">
    <el-breadcrumb-item v-for="item in levelList" :key="item.frontendUrl">
      <span class="no-redirect">{{ item.menuName }}</span>
    </el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script>
import store from '@/store';
import { pathToRegexp } from 'path-to-regexp';
export default {
  data() {
    return {
      levelList: null
    };
  },
  watch: {
    $route(route) {
      if (route.path.startsWith('/redirect/')) {
        return;
      }
      this.getBreadcrumb();
    }
  },
  computed: {
    APP_MENUS() {
      return store.getters.menus;
    }
  },
  created() {
    this.getBreadcrumb();
  },
  methods: {
    getBreadcrumb() {
      const path = this.$route.path;
      
      // 递归查找路径对应的菜单及其父级
      function findPath(menus, path, parentPath = []) {
        for (const menu of menus) {
          // 支持 path-to-regexp 匹配
          if (menu.frontendUrl && pathToRegexp(menu.frontendUrl).test(path)) {
            return [...parentPath, menu];
          }
          if (menu.children) {
            const found = findPath(menu.children, path, [...parentPath, menu]);
            if (found) return found;
          }
        }
        return null;
      }

      this.levelList = findPath(this.APP_MENUS, path) || [];
    }
  }
};
</script>
<style lang="scss" scoped>
.app-breadcrumb {
  flex-shrink: 0;
  font-size: 12px;
  font-weight: bold;
  min-width: 80px;
  height:32px;
  line-height: 32px;
}
.no-redirect {
  font-size: 12px;
  font-weight: bold;
}
</style>
